export * from './time-filter-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/filter/time-filter-item/index.ts